import { api } from "./client";
import type { LoginResponse, AuthUser, Branch } from "./types";

export async function fetchBranches(): Promise<Branch[]> {
  return await api.post<Branch[]>("/setting/get/branch", { body: {} });
}

export async function login(email: string, branch: number, password: string): Promise<LoginResponse> {
  return await api.post<LoginResponse>("/users/v2/login", { body: { email, branch, password } });
}

export async function fetchCurrentUser(token: string): Promise<AuthUser | null> {
  try {
    const res = await api.post<{ status: boolean; user?: AuthUser }>("/users/me", { body: {}, token });
    return res.user ?? null;
  } catch {
    return null;
  }
}
